import React, { useState } from "react";
import { FiX, FiUser } from "react-icons/fi";
import "./ProfileEditModal.css";

const ProfileEditModal = ({ userData, onClose, onSave, loading }) => {
  const [form, setForm] = useState({
    name: userData?.name || "",
    email: userData?.email || "",
    phone: userData?.phone || "",
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required";
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email))
      e.email = "Valid email required";
    if (!form.phone.trim()) e.phone = "Phone is required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSave(form);
  };

  return (
    <div className="pem-overlay" onClick={onClose}>
      <div className="pem-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pem-header">
          <h2>Edit Profile Information</h2>
          <button className="pem-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>

        <div className="pem-body">
          <div className="pem-avatar-section">
            <div className="pem-avatar">
              <FiUser size={36} />
            </div>
            {/* <button className="pem-change-photo">Change Photo</button> */}
          </div>

          {[
            {
              label: "Full Name",
              field: "name",
              type: "text",
              placeholder: "Enter your full name",
            },
            {
              label: "Email Address",
              field: "email",
              type: "email",
              placeholder: "Enter your email",
            },
            {
              label: "Phone Number",
              field: "phone",
              type: "tel",
              placeholder: "Enter your phone number",
            },
          ].map(({ label, field, type, placeholder }) => (
            <div key={field} className="pem-field">
              <label>{label}</label>
              <input
                type={type}
                value={form[field]}
                placeholder={placeholder}
                className={errors[field] ? "input-error" : ""}
                onChange={(e) => {
                  setForm((prev) => ({ ...prev, [field]: e.target.value }));
                  if (errors[field])
                    setErrors((prev) => ({ ...prev, [field]: null }));
                }}
              />
              {errors[field] && (
                <span className="error-text">{errors[field]}</span>
              )}
            </div>
          ))}
        </div>

        <div className="pem-footer">
          <button className="btn-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="btn-save" onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileEditModal;
